export default [
    "123456789",
    "password",
    "12345678",
    "password1",
    "1234567890",
    "iloveyou",
    "1q2w3e4r5t",
    "qwertyuiop",
    "myspace1",
    "1qaz2wsx",
    "target123",
    "1g2w3e4r",
    "gwerty123",
    "zag12wsx",
    "1q2w3e4r",
    "987654321",
    "qwerty123",
    "asdfghjkl",
    "123123123",
    "computer",
    "iloveyou1",
    "fuckyou1",
    "princess",
    "789456123",
    "11111111",
    "princess1",
    "linkedin",
    "sunshine",
    "football",
    "1234qwer",
    "j38ifUbn",
    "football1",
    "123456789a",
    "abcd1234",
    "jordan23",
    "88888888",
    "12qwaszx",
    "FQRG7CS493",
    "superman",
    "blink182",
    "michael1",
    "babygirl1",
    "baseball",
    "0123456789",
    "iloveyou2",
    "147258369",
    "michelle",
    "q1w2e3r4",
    "jessica1",
    "qwer1234",
    "liverpool",
    "fuckyou2",
    "1111111111",
    "qazwsxedc",
    "baseball1",
    "0987654321",
    "anthony1",
    "jennifer",
    "00000000",
    "29rsavoy",
    "basketball",
    "qwerty12",
    "charlie1",
    "passw0rd",
    "asshole1",
    "superman1",
    "password12",
    "sunshine1",
    "babygirl",
    "trustno1",
    "asdf1234",
    "chocolate",
    "password2",
    "12341234",
    "samantha",
    "12344321",
    "q1w2e3r4t5y6",
    "qweasdzxc",
    "internet",
    "a123456789",
    "VQsaBLPzLa",
    "hello123",
    "butterfly",
    "1qazxsw2",
    "cjmasterinf",
    "brandon1",
    "1234567891",
    "whatever",
    "alexander",
    "PE#5GZ29PTZMSE",
    "dpbk1234",
    "DIOSESFIEL",
    "pakistan",
    "123654789",
    "matthew1",
    "3rJs1la7qE",
    "пїЅпїЅпїЅпїЅпїЅпїЅ",
    "barcelona",
    "computer1",
    "michelle1",
    "12345678910",
    "jonathan",
    "liverpool1",
    "mercedes",
    "11223344",
    "victoria",
    "12345qwert",
    "111222tianya",
    "william1",
    "chicken1",
    "0000000000",
    "jasmine1",
    "benjamin",
    "welcome1",
    "starwars",
    "christian",
    "1234554321",
    "chocolate1",
    "butterfly1",
    "q1w2e3r4t5",
    "slipknot",
    "zaq12wsx",
    "147852369",
    "elizabeth",
    "87654321",
    "1password",
    "america1",
    "metallica",
    "chelsea1",
    "1234567a",
    "iw14Fi9j",
    "juventus",
    "jennifer1",
    "999999999",
    "elizabeth1",
    "123qweasd",
    "tinkerbell",
    "samantha1",
    "Sojdlg123aljg",
    "myspace123",
    "freedom1",
    "whatever1",
    "valentina",
    "741852963",
    "spongebob1",
    "1234abcd",
    "hellokitty",
    "madison1",
    "cocacola",
    "nicholas",
    "qwertyui",
    "spiderman",
    "diamond1",
    "danielle",
    "pokemon1",
    "mustang1",
    "1qaz2wsx3edc",
    "justinbieb",
    "friends1",
    "asdfasdf",
    "qwerty12345",
    "123hfjdk147",
    "password123",
    "iloveyou!",
    "fuckoff1",
    "bubbles1",
    "a1b2c3d4",
    "123456789q",
    "heather1",
    "4815162342",
    "yankees1",
    "asdfghjkl1",
    "1q2w3e4r5t6y",
    "patrick1",
    "12121212",
    "alexander1",
    "raiders1",
    "Password1",
    "sebastian",
    "zxcvbnm1",
    "melissa1",
    "slipknot1",
    "spiderman1",
    "cowboys1",
    "a1234567",
    "november",
    "alexandra",
    "veronica",
    "cristina",
    "newyork1",
    "jackson1",
    "iloveyou12",
    "PolniyPizdec0211",
    "password!",
    "a838hfiD",
    "richard1",
    "beautiful1",
    "carolina",
    "patricia",
    "stephanie",
    "421uiopy258",
    "myspace2",
    "scorpion",
    "monster1",
    "elephant",
    "963852741",
    "destiny1",
    "123456abc",
    "december",
    "9876543210",
    "manchester",
    "midnight",
    "12345678a",
    "пїЅпїЅпїЅпїЅпїЅпїЅпїЅ",
    "kristina",
    "lovelove",
    "gangsta1",
    "charlotte",
    "scooter1",
    "caroline",
    "super123",
    "marseille",
    "metallica1",
    "beautiful",
    "danielle1",
    "blessed1",
    "1029384756",
    "qazwsx123",
    "california",
    "christian1",
    "arsenal1",
    "babyboy1",
    "1122334455",
    "aa123456",
    "forever1",
    "Password",
    "1a2b3c4d",
    "playboy1",
    "creative",
    "пїЅпїЅпїЅпїЅпїЅпїЅпїЅпїЅ",
    "maverick",
    "brittany1",
    "letmein1",
    "cameron1",
    "spongebob",
    "uQA9Ebw445",
    "fernando",
    "startfinding",
    "softball",
    "dolphin1",
    "qwerty1234",
    "alejandro",
    "september",
    "isabella",
    "abc123456",
    "password3",
    "abcdefg123",
    "loveyou1",
    "leonardo",
    "password.",
    "samsung1",
    "qwert123",
    "poohbear",
    "garfield",
    "YAgjecc826",
    "qwerty123456",
    "steelers",
    "iloveme1",
    "nicholas1",
    "portugal",
    "precious",
    "jackass1",
    "jonathan1",
    "rainbow1",
    "angel123",
    "fuckyou!",
    "starwars1",
    "tiffany1",
    "poohbear1",
    "marlboro",
    "hardcore",
    "1234512345",
    "qq123456",
    "abcdefg1",
    "crystal1",
    "azertyuiop",
    "angelina",
    "svetlana",
    "icecream",
    "popcorn1",
    "victoria1",
    "twilight",
    "brittany",
    "snickers",
    "aaaaaaaa",
    "swordfish",
    "fyfcnfcbz",
    "rockstar1",
    "yourmom1",
    "christine",
    "steelers1",
    "shannon1",
    "peaches1",
    "florida1",
    "stephanie1",
    "lollipop",
    "greenday1",
    "iverson3",
    "motorola",
    "rockstar",
    "lakers24",
    "southside1",
    "bismillah",
    "pa55word",
    "emmanuel",
    "5555555555",
    "password11",
    "love4ever",
    "greenday",
    "isabelle",
    "babygurl1",
    "santiago",
    "chester1",
    "kimberly",
    "happy123",
    "55555555",
    "satan666",
    "francesco",
    "vanessa1",
    "a12345678",
    "corvette",
    "realmadrid",
    "1123581321",
    "soccer12",
    "fktrcfylh",
    "qwert12345",
    "1v7Upjw3nT",
    "p@ssw0rd",
    "thunder1",
    "zxcvbnm123",
    "midnight1",
    "lebron23",
    "strawberry",
    "love1234",
    "soccer10"
];
//# sourceMappingURL=data:application/json;base64,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